import { render, staticRenderFns } from "./BlockCitySelector.vue?vue&type=template&id=bd7c13c0"
import script from "./BlockCitySelector.vue?vue&type=script&lang=js"
export * from "./BlockCitySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports